import React, {useEffect, useState} from "react";
import Shortcut from "../components/shortcut/shortcut";
import ComingEventsCalendar from "../components/coming-events/coming-events-calendar";

import {FAILED, getRequest, LOADING, SUCCESS} from "../httpClient";
import Loading from "../components/utils/loading";
import ErrorMessage from "../components/utils/error-message";
import {useDispatch, useSelector} from "react-redux";
import {useAuth} from "oidc-react";
import {
    fetchAttendanceStatisticsAsync,
    fetchFinanceProjectionAsync,
    fetchFinanceStatisticsAsync
} from "../features/statistics/statisticsSlice";
import AttendanceStatisticsChart from "../components/charts/attendance-statistics-chart";
import {ChartContainer} from "../components/charts/chart-container";
import FinanceStatisticsChart from "../components/charts/finance-statistics-chart";
import {loadIAMGroupsAsync} from "../features/user-management/iamSlice";
import {FinanceProjectionChart} from "../components/charts/finance-projection-chart";

const LandingPage = () => {
    const dispatch = useDispatch();
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [status, setStatus] = useState(LOADING);
    const [attendanceStatisticsFilter, setAttendanceStatisticsFilter] = useState('year');
    const [financeStatisticsFilter, setFinanceStatisticsFilter] = useState('year');

    const {roles} = useSelector(state => state.user);
    const auth = useAuth();


    useEffect(() => {
        if (auth && auth.userData) {
            if (calendarEvents.length === 0) {
                loadCalendarEvents();
            }

        }
    }, [auth.userData]);

    const {
        attendanceStatistics,
        financeStatistics,
        financeProjection
    } = useSelector(state => state.statistics);

    useEffect(() => {
        if (auth && auth.userData) {
            dispatch(fetchAttendanceStatisticsAsync({
                token: auth.userData.access_token,
                groupBy: attendanceStatisticsFilter
            }));
        }
    }, [auth.userData, attendanceStatisticsFilter]);

    useEffect(() => {
        if (auth && auth.userData) {
            dispatch(fetchFinanceStatisticsAsync({
                token: auth.userData.access_token,
                groupBy: financeStatisticsFilter
            }));
        }
    }, [auth.userData, financeStatisticsFilter]);

    useEffect(() => {
        if (auth && auth.userData) {
            dispatch(fetchFinanceProjectionAsync(auth.userData.access_token));
        }
    }, [auth.userData]);

    const rolesString = roles.toString();

    const loadCalendarEvents = () => {
        getRequest(`/v2/event/calendar?numberPerPage=50&page=0`, auth.userData?.access_token)
            .then(resp => {
                if (resp.ok) {
                    return resp.json();
                }
                throw resp;
            })
            .then(data => {
                setCalendarEvents(data);
                setStatus('');
            })
            .catch(err => {
                console.log(err);
                setStatus(FAILED)
            })
    }


    return (
        <div>
            {
                status === LOADING ?
                    <Loading message={'loading calendar'}/>
                    :
                    status === FAILED ?
                        <ErrorMessage variant={'h6'}
                                      component={'div'}
                                      message={'could not load calendar.. please try again later'}
                                      action actionMessage={'reload'} performAction={() => window.location.reload()}/>
                        :
                        <>
                            <ComingEventsCalendar events={calendarEvents ? calendarEvents : []}
                                                  officer={rolesString.includes("officer")}
                                                  reload={loadCalendarEvents}/>
                            <ChartContainer>
                                <AttendanceStatisticsChart chartData={attendanceStatistics}
                                                           filter={attendanceStatisticsFilter}
                                                           handleFilter={setAttendanceStatisticsFilter}/>
                            </ChartContainer>

                            <ChartContainer>
                                    <FinanceStatisticsChart chartData={financeStatistics}
                                                            filter={financeStatisticsFilter}
                                                            handleFilter={setFinanceStatisticsFilter}/>
                            </ChartContainer>

                            <ChartContainer>
                                <FinanceProjectionChart chartData={financeProjection}/>
                            </ChartContainer>
                        </>
            }
            <Shortcut roles={roles}/>
        </div>
    )
};
export default LandingPage;
